import React, { useEffect, useState } from 'react'
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './tour.css'
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Carousel from 'react-multi-carousel'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Link, useNavigate } from 'react-router-dom'
import { packageCity, packageGet } from '../../api/package'
import dayjs from 'dayjs'
import { city } from '../../api/airport'
import { getImageUrl } from '../../utils/imageUrl'
// -------------------------------------------------


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const destination = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
    slidesToSlide: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
}

const Tour = () => {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate()
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [tourDetail, setTourDetail] = useState({
    city: '',
    type: ''
  })

  const [tourData, setTourData] = useState([])
  const [tourInternationalData, setTourInternationalData] = useState([])
  const [tourCorporateData, setTourCorporateData] = useState([])
  const getPackages = async () => {
    if (tourDetail.type === '') {
      alert('Please fill type')
    } else if (tourDetail.city === '') {
      alert('Please fill City')
    } else {
      const resp = await packageGet(tourDetail)
      const filterInterNational = resp.data?.filter((item) => {
        return item?.packageMode === 'International'
      })
      const national = resp.data?.filter((item) => {
        return item?.packageMode === 'National'
      })
      const corporate = resp.data?.filter((item) => {
        return item?.packageMode === 'Corporate'
      })
      setTourInternationalData(filterInterNational)
      setTourData(national)
      setTourCorporateData(corporate)
    }
  }


  const getPackage = async () => {
    const resp = await packageGet()
    const filterInterNational = resp.data?.filter((item) => {
      return item?.packageMode === 'International'
    })
    const national = resp.data?.filter((item) => {
      return item?.packageMode === 'National'
    })
    const corporate = resp.data?.filter((item) => {
      return item?.packageMode === 'Corporate'
    })
    setTourInternationalData(filterInterNational)
    setTourData(national)
    setTourCorporateData(corporate)
  }

  useEffect(() => {
    getPackage()
  }, [])

  const [cities, setCities] = useState([])

  const getCities = async () => {
    const resp = await packageCity()
    setCities(resp.data)
  }

  useEffect(() => {
    getCities()
  }, [])
  const City = cities?.map((items) => ({ label: items?.name, value: items?.name }))
  const [fromDate, setFromDate] = useState(dayjs())

  return (
    <>
      <Header />
      <section className=''>
        <div className='container'>
          <div className="mainBannerSectionTour">
            <div className="row">
              <div className="col-md-12">
                <h1 className="text-dark">Life Is Adventure Make The Best Of It</h1>
                <p>Planning for a trip? we will organize your best trip with the best destination and within the best budgets!</p>
              </div>
              {/* <div className="col-md-3">
                <div className="card shadow p-2 pb-0">
                  <div className="position-absolute top-0 start-0 mt-n3 ms-n3 z-index-9">
                    <img src="./images/offImg.svg" className="position-relative h-70px" alt="" />
                    <span className="h5 text-white position-absolute top-50 start-50 translate-middle">40%</span>
                  </div>
                  <div className="rounded-3 overflow-hidden position-relative">
                    <img src="./images/05.jpg" className="card-img" alt="" />
                    <div className="card-img-overlay d-flex">
                      <h6 className="text-white fw-normal mt-auto mb-0">5 Days / 4 Nights</h6>
                    </div>
                  </div>
                  <div className="card-body px-2">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <a href="#" className="badge bg-primary bg-opacity-10 text-primary">Adventure</a>
                      <h6 className="d-flex m-0">
                        <svg style={{ width: '15px' }} className="svg-inline--fa fa-star text-warning me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                          <path className="" fill="currentColor" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"></path>
                        </svg>
                        4.5
                      </h6>
                    </div>
                    <h6 className="card-title"><a href="#">Maldives Sightseeing &amp; Adventure Tour</a></h6>
                    <div className="d-flex justify-content-between align-items-center mb-0">
                      <h6 className="text-success mb-0">$385 <span className="fw-light">/person</span></h6>
                      <span className="text-decoration-line-through mb-0 text-reset">$682</span>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <Box
            className="boxM"
            sx={{
              width: '90%',
              margin: '-80px auto 0px auto',
              backgroundColor: '#fff',
              borderRadius: '25px',
              boxShadow: '0px 0px 40px rgba(29, 58, 83, .1)',
              overflow: 'hidden',
              padding: '0 15px',
            }}>
            <div className='row'>
              <div className='col-md-3 col-lg-3'>
                <div className='py-3'>
                  <label className="mb-1"><i className="fa-solid fa-location-dot"></i> Location</label>
                  <Autocomplete
                    size='small'
                    sx={{ mt: 1 }}
                    disablePortal
                    id="combo-box-demo"
                    options={City}
                    getOptionLabel={(option) => {
                      if (option.label) {
                        return option.label
                      } else if (typeof option === 'string') {
                        return option
                      } else {
                        return ""
                      }
                    }
                    }
                    isOptionEqualToValue={(option, value) => {
                      if (option.value && value.value) { return option.value === value.value } else {
                        return false
                      }
                    }}
                    value={tourDetail.city}
                    onChange={(e, newValue) => {
                      if (newValue !== null) {
                        setTourDetail({
                          ...tourDetail,
                          city: newValue.value
                        })
                      } else {
                        return;
                      }

                    }}
                    renderInput={(params) => <TextField {...params} label="Select Location" />}
                  />
                </div>
              </div>
              <div className='col-md-3 col-lg-3'>
                <div className='py-3'>
                  <label className="mb-1"><i className="fa-solid fa-location-arrow"></i> Package type</label>
                  <Autocomplete
                    size='small'
                    sx={{ mt: 1 }}
                    disablePortal
                    id="combo-box-demo"
                    options={tourType}
                    value={tourDetail.type}
                    getOptionLabel={(option) => {
                      if (option.label) {
                        return option.label
                      } else if (typeof option === 'string') {
                        return option
                      } else {
                        return ""
                      }
                    }
                    }
                    isOptionEqualToValue={(option, value) => {
                      if (option.value && value.value) { return option.value === value.value } else {
                        return false
                      }
                    }}
                    onChange={(e, newValue) => {
                      if (newValue !== null) {
                        setTourDetail({
                          ...tourDetail,
                          type: newValue.value
                        })
                      } else {
                        return;
                      }

                    }}
                    renderInput={(params) => <TextField {...params} label="Select Type" />}
                  />
                </div>
              </div>
              <div className='col-md-2 col-lg-2 dateCol'>
                <div className='py-3'>
                  <label className="mb-1"><i className="fa-solid fa-calendar"></i> Start Date</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker']}>
                      <DatePicker
                        slotProps={{ textField: { size: 'small' } }}
                        label="Start date"
                        minDate={dayjs()}
                        value={fromDate}
                        onChange={(newValue) => {
                          const date = new Date(newValue['$d']);
                          setFromDate(date)

                          localStorage.setItem('from', date)



                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
              </div>
              <div className='col-md-2 col-lg-2 dateCol'>
                <div className='py-3'>
                  <label className="mb-1"><i className="fa-solid fa-calendar"></i> End Date</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker']}>
                      <DatePicker
                        slotProps={{ textField: { size: 'small' } }}
                        label="End date"
                        minDate={dayjs(fromDate) || dayjs()}
                        onChange={(newValue) => {
                          const date = new Date(newValue['$d']);

                          localStorage.setItem('to', date)



                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
              </div>
              <div className="col-md-2 col-lg-2">
                <div className='d-flex align-items-end justify-content-center h-100'>
                  <button
                    onClick={getPackages}
                    className="btn btn-dark px-4 mb-3">
                    Search
                  </button>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </section>

      {/* <section className='recentSearches'>
        <div className='container'>
          <div className="row g-2 mt-6">
            <div className="col-lg-2">
              <h4 className="mb-0">Recent Searches</h4>
            </div>
            <div className="col-lg-10">
              <div className="hstack flex-wrap gap-3">
                <div className="alert bg-light fade show small px-3 py-1 mb-0" role="alert">
                  <span className="me-1">Taman Sari</span>
                  <button type="button" className="btn-close small p-2 ms-1" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div className="alert bg-light fade show small px-3 py-1 mb-0" role="alert">
                  <span className="me-1">The Grand Palace</span>
                  <button type="button" className="btn-close small p-2 ms-1" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div className="alert bg-light fade show small px-3 py-1 mb-0" role="alert">
                  <span className="me-1">Glacier National Park</span>
                  <button type="button" className="btn-close small p-2 ms-1" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div className="alert bg-light fade show small px-3 py-1 mb-0" role="alert">
                  <span className="me-1">Machu Picchu</span>
                  <button type="button" className="btn-close small p-2 ms-1" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div className="alert bg-light fade show small px-3 py-1 mb-0" role="alert">
                  <span className="me-1">Prambanan Temple</span>
                  <button type="button" className="btn-close small p-2 ms-1" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div className="alert bg-light fade show small px-3 py-1 mb-0" role="alert">
                  <span className="me-1">Batu Gong</span>
                  <button type="button" className="btn-close small p-2 ms-1" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div className="alert bg-light fade show small px-3 py-1 mb-0" role="alert">
                  <span className="me-1">Barobadur Temple</span>
                  <button type="button" className="btn-close small p-2 ms-1" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div className="alert bg-light fade show small px-3 py-1 mb-0" role="alert">
                  <span className="me-1">Great Barrier Reef</span>
                  <button type="button" className="btn-close small p-2 ms-1" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div className="alert bg-light fade show small px-3 py-1 mb-0" role="alert">
                  <span className="me-1">Argentine Patagonia</span>
                  <button type="button" className="btn-close small p-2 ms-1" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <button type="button" className="btn btn-sm btn-primary-soft mb-0">Clear all</button>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-10">
              <h4 className="mb-0 title">International Packages</h4>
            </div>
            <div className="col-2 text-end">
              <Link to="/tours/International" className="btn btn-lg btn-dark mb-0">View All</Link>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              {tourInternationalData?.map((items) => (
                <div onClick={() => {
                  navigate(`/tourDetail/${items?._id}`)
                }}

                  key={items?._id} className="destination">
                  <Box className="eximg-group g-bg-4 tourIm">
                    <img className="" src={getImageUrl(items?.images?.[0])} alt='' />
                    {/* <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6> */}
                  </Box>
                  <div className='py-2'>
                    <div className="py-2">
                      <h5 className="card-title">
                        <a href="#!">{items?.packageName} </a>
                      </h5>
                    </div>
                    <div className="hstack gap-2">
                      <span className="h5 mb-0 text-success">₹ {items?.price}</span>
                      <small>Starting price</small>
                    </div>
                  </div>
                </div>
              ))}
              {/* <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div> */}
            </Carousel>
          </div >
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-10">
              <h4 className="mb-0 title">Corporate Packages</h4>
            </div>
            <div className="col-2 text-end">
              <Link to="/tours/Corporate" className="btn btn-lg btn-dark mb-0">View All</Link>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              {tourCorporateData?.map((items) => (
                <div onClick={() => {
                  navigate(`/tourDetail/${items?._id}`)
                }}

                  key={items?._id} className="destination">
                  <Box className="eximg-group g-bg-4 tourIm">
                    <img className="" src={getImageUrl(items?.images?.[0])} alt='' />
                    {/* <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6> */}
                  </Box>
                  <div className='py-2'>
                    <div className="py-2">
                      <h5 className="card-title">
                        <a href="#!">{items?.packageName}</a>
                      </h5>
                    </div>
                    <div className="hstack gap-2">
                      <span className="h5 mb-0 text-success">₹ {items?.price}</span>
                      <small>Starting price</small>
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          </div >
        </div >
      </section >

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-10">
              <h4 className="mb-0 title">Domestic Packages</h4>
            </div>
            <div className="col-2 text-end">
              <Link to="/tours/Domestic" className="btn btn-lg btn-dark mb-0">View All</Link>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              {tourData?.map((items) => (
                <div onClick={() => {
                  navigate(`/tourDetail/${items?._id}`)
                }}

                  key={items?._id} className="destination">
                  <Box className="eximg-group g-bg-4 tourIm">
                    <img className="" src={getImageUrl(items?.images?.[0])} alt='' />
                    {/* <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6> */}
                  </Box>
                  <div className='py-2'>
                    <div className="py-2">
                      <h5 className="card-title">
                        <a href="#!">{items?.packageName}</a>
                      </h5>
                    </div>
                    <div className="hstack gap-2">
                      <span className="h5 mb-0 text-success">₹ {items?.price}</span>
                      <small>Starting price</small>
                    </div>
                  </div>
                </div>
              ))}
              {/* <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div> */}
            </Carousel>
          </div >
        </div >
      </section >

      <section className='specialOffers'>
        <div className='container'>
          <div className="bg-light rounded-3 position-relative p-4 p-sm-5">
            <div className="row align-items-center position-relative dicoverSec">
              <div className="col-lg-8">
                <div className="d-flex">
                  <h3>It's time to discover</h3>
                  <img src="images/04-DrYI6v5l.svg" className="h-40px ms-3" alt="" />
                </div>
                <p className="mb-3 mb-lg-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.  </p>
              </div>
              <div className="col-lg-4 text-lg-end"><Link to="/tour" className="btn btn-lg btn-dark mb-0">Book Now</Link></div>
            </div>
          </div>
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Top Categories</h4>
            </div>
          </div>
          <div className="row g-4 g-xl-5 topCate">
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Adventure`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/19-BYcWTs_B.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Adventure</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/SoundScape`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/13-CeWMv36_.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Sound Scape</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Desert`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/18-C_X3yjnw.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Desert</a></h5>
                    {/* <span>1587 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Pilgrims`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/19-BYcWTs_B.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Pilgrims</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/History`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/17-E7K6iGPB.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">History</a></h5>
                    {/* <span>986 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/IslandHopper`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/14-fpi-ZIwa.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">IslandHopper</a></h5>
                    {/* <span>786 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/General`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/16-D1cIRfhu.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">General</a></h5>
                    {/* <span>786 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Haunted`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/15-CGaqJfSo.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Haunted</a></h5>
                    {/* <span>568 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/14-fpi-ZIwa.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Temple</a></h5>
                    <span>256 Places</span>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/13-CeWMv36_.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Festival</a></h5>
                    <span>654 Places</span>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}

export default Tour

const tourType = [
  { label: 'Adventure', value: 'Adventure' },
  { label: 'IslandHopper', value: 'IslandHopper' },
  { label: 'Desert', value: 'Desert' },
  { label: 'History', value: 'History' },
  { label: 'Haunted', value: 'Haunted' },
  { label: 'Sound Scape', value: 'SoundScape' },
  { label: 'General', value: 'General' },
  { label: 'Pilgrims', value: 'Pilgrims' },
]

const cities = [{
  label: 'Mumbai', value: 'Mumbai',
},
{
  label: 'Palwal', value: 'Palwal',
}]